"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorDetails = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var error_1 = require("../../../next-api-error/error");
/**
 * Render more information about the error, including the stack trace.
 */
function ErrorDetails(_a) {
    var error = _a.error;
    if ((0, error_1.isNextApiErrorLike)(error)) {
        return (react_1.default.createElement(core_ui_1.Stack, { gap: 8, direction: "vertical" },
            react_1.default.createElement(StyledPre, null,
                error.method,
                " ",
                error.url),
            react_1.default.createElement(StyledPre, null, JSON.stringify(error.data, null, 2)),
            react_1.default.createElement(StyledPre, null, error.stack)));
    }
    return (react_1.default.createElement(core_ui_1.Stack, { gap: 8, direction: "vertical" },
        react_1.default.createElement(StyledPre, null, error.message),
        react_1.default.createElement(StyledPre, null, error.stack)));
}
exports.ErrorDetails = ErrorDetails;
var StyledPre = styled_components_1.default.pre(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  display: block;\n  width: 100%;\n  padding: 16px;\n  box-sizing: border-box;\n  line-height: 16px;\n  color: ", ";\n  overflow-x: scroll;\n  margin: 0;\n"], ["\n  background-color: ", ";\n  display: block;\n  width: 100%;\n  padding: 16px;\n  box-sizing: border-box;\n  line-height: 16px;\n  color: ", ";\n  overflow-x: scroll;\n  margin: 0;\n"])), core_ui_1.colors.steel[100], core_ui_1.colors.steel[400]);
var templateObject_1;
